<template>
	<div class="c-folder-block" @click.prevent="onClick" tabindex="0" ref="block">
		<div class="c-folder-block__block-holder">
			<div class="c-folder-block__block">
				<div v-if="block.blocks.length > 0">
					<span>Some text here</span>
					<span>A big chunky paragraph here. Noice stuff. Hmm</span>
					<br />
					<br />
					<span>Some more text here</span>
					<br />
					<span>A big chunky paragraph here</span>
				</div>
			</div>
			<div
				class="c-folder-block__block"
				v-for="index in fakeBlockLength"
				:key="index"
			></div>
		</div>
		<div class="c-folder-block__body">
			<!-- <input
				v-if="folder"
				type="text"
				@change="onUpdate"
				v-model="folder.content.title"
				disabled
			/> -->
			<transition name="fade" mode="out-in">
				<input
					v-if="edit"
					v-model="title"
					ref="input"
					@change="onUpdate"
					@keyup.enter="stopEdit"
					@blur="onBlur"
				/>
				<h4 v-if="!edit">{{ block.content.title }}</h4>
			</transition>
			<span v-if="parentBlock">{{ block.blocks.length }} block{{ s }}</span>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			edit: false,
			title: '',
		};
	},

	props: {
		block: {
			type: Object,
		},
	},

	watch: {
		focusTrigger: function () {
			if (this.focusId && this.focusId === this.block._id && this.$refs.block) {
				this.$refs.block.focus();
			}
		},
	},

	computed: {
		focusTrigger: function () {
			return this.$store.getters['dashboard/focusTrigger'];
		},
		focusId: function () {
			return this.$store.getters['dashboard/focusId'];
		},
		fakeBlockLength: function () {
			let len = this.block.blocks.length;
			let limit = 4;
			if (len >= limit) {
				len = limit;
			}
			if (len !== 0) {
				len = len - 1;
			}
			return len;
		},
		parentBlock: function () {
			return this.$store.getters['block/parentBlock'](this.block.parent);
		},
		href: function () {
			return `/f/${this.block._id}`;
		},
		s: function () {
			if (this.block.blocks.length === 1) {
				return '';
			} else {
				return 's';
			}
		},
	},

	methods: {
		onUpdate: function (e) {
			let block = JSON.parse(JSON.stringify(this.block));
			block.content.title = e.target.value;
			this.$emit('update', block);
			//this.$store.dispatch('block/updateBlock', block);
		},
		startEdit: function () {
			this.edit = true;
			setTimeout(() => {
				if (this.$refs.input) {
					this.$refs.input.focus();
				}
			}, 120);
		},
		stopEdit: function (e) {
			this.edit = false;
		},
		onBlur: function (e) {
			let block = JSON.parse(JSON.stringify(this.block));
			block.content.title = e.target.value;
			this.$emit('update', block);
			//this.$store.dispatch('block/updateBlock', block);
			this.stopEdit();
		},
		onClick: function (e) {
			if (e.target.nodeName === 'H4') {
				this.startEdit();
				return;
			}
			if (e.target.nodeName === 'INPUT') {
				return;
			}
			if (e.target.nodeName !== 'H4') {
				this.stopEdit();
				this.$router.push({
					path: `/b/${this.block._id}`,
				});
				//this.$store.dispatch('dashboard/setCurrentBlock', this.block._id);
			}
		},
	},

	mounted: function () {
		if (this.block.content) {
			this.title = this.block.content.title;
		} else {
			console.log('EXCEPTION');
			console.log(this.block);
		}
	},
};
</script>

<style lang="scss">
.c-folder-block {
	display: flex;
	padding: 5px var(--margin-lg);
	padding-left: 0;
	//background-color: var(--g3);
	border-radius: var(--border-radius);
	cursor: pointer;
	color: var(--font-color);
	text-transform: none !important;
	transition: background-color var(--transition-time) ease-out,
		transform var(--transition-time) ease-out,
		box-shadow var(--transition-time) ease-out;

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity var(--transition-time-sm);
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	&__block-holder {
		position: relative;
		width: 30px;
		height: 38px;
		transition: transform var(--transition-time) ease-out;
		//transform: translateX(var(--margin));
	}

	&__block {
		position: absolute;
		padding: 3px 4px;
		z-index: 4;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: var(--g4);
		border-radius: var(--border-radius);
		box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.2);
		border: var(--g1) solid 1px;
		font-size: 2px;
		transition: transform var(--transition-time) ease-out;

		&:nth-child(2) {
			z-index: 3;
			opacity: 0.9;
			transform: translateX(-1px) rotate(-6deg);
		}
		&:nth-child(3) {
			z-index: 2;
			opacity: 0.85;
			transform: translateY(2px) rotate(9deg);
		}
		&:nth-child(4) {
			z-index: 1;
			opacity: 0.8;
			transform: translateY(0px) rotate(10deg);
		}
		&:nth-child(4) {
			z-index: 1;
			opacity: 0.75;
			transform: translateY(-2px) rotate(-5deg);
		}

		span {
			display: inline;
			line-height: 2;
			box-decoration-break: slice;
			color: transparent;
			background-color: rgba(127, 127, 127, 0.5);
			user-select: none;
		}
	}

	&__body {
		flex-grow: 1;
		margin-left: var(--spacer-sm);

		input {
			cursor: text;
			padding: 0;
			border: none;
			-webkit-appearance: none;
			background-color: transparent;
			font-size: var(--font-size);
			letter-spacing: 0.4px;
			font-weight: 600;
			color: var(--body-color);
			border-radius: var(--border-radius-sm);

			&:hover {
				background-color: var(--g4);
			}

			&:focus {
				outline: none;
				@include focus(2px);
			}
		}

		h4 {
			cursor: text;
			display: inline-block;
			margin-bottom: 0;
			transition: all var(--transition-time-sm) ease-out;
			border-radius: var(--border-radius-sm);

			&:hover {
				background-color: var(--g5);
			}
		}

		span {
			display: block;
			opacity: 0.75;
			font-size: var(--font-size-sm);
			line-height: 1;
		}
	}

	&:hover,
	&:active,
	&:focus {
		outline: none;
		background-color: var(--g3);
		.c-folder-block__block-holder {
			transform: translateX(var(--margin-lg));

			.c-folder-block__block {
				box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.125);
				&:nth-child(2) {
					transform: translate(-1px, 0) rotate(0deg);
				}
				&:nth-child(3) {
					transform: translate(-2px, 0px) rotate(0deg);
				}
				&:nth-child(4) {
					transform: translate(-3px, 0px) rotate(0deg);
				}
				&:nth-child(4) {
					transform: translate(-4px, 0px) rotate(0deg);
				}
			}
		}
	}
}
</style>